import { getAnalyticsService, AnalyticsEvent } from './index';

export interface TrackViewLoadedOptions {
  loadMs: number;
  rowsVisibleCount: number;
  screen: string;
  viewType?: 'list' | 'calendar';
}

export interface TrackViewLoadFailedOptions {
  errorCode: string;
  screen: string;
  loadMs?: number;
  errorMessage?: string;
  viewType?: 'list' | 'calendar';
}

export const trackViewLoaded = ({ loadMs, rowsVisibleCount, screen, viewType }: TrackViewLoadedOptions): void => {
  const service = getAnalyticsService();
  service.trackEvent(AnalyticsEvent.PlanningViewLoaded, {
    load_ms: loadMs,
    rows_visible_count: rowsVisibleCount,
    screen,
    ...(viewType !== undefined && { view_type: viewType }),
  });
};

export const trackViewLoadFailed = ({
  errorCode,
  screen,
  loadMs,
  errorMessage,
  viewType,
}: TrackViewLoadFailedOptions): void => {
  const service = getAnalyticsService();
  service.trackEvent(AnalyticsEvent.ViewLoadFailed, {
    error_code: errorCode,
    screen,
    ...(loadMs !== undefined && { load_ms: loadMs }),
    ...(errorMessage !== undefined && { error_message: errorMessage.slice(0, 256) }),
    ...(viewType !== undefined && { view_type: viewType }),
  });
};
